import { createSlice } from "@reduxjs/toolkit";
import { InitialReviews } from "../domain/models/Review";
import { ReviewServiceImpl } from "../services/ReviewServiceImpl";
import { ReviewDTO } from "../domain/models/dto/ReviewDTO";
import { TFunction } from "i18next";
import { getCreatedTime } from "../tools/DatetimeTools";
import { AppState } from "../store";
import { handleCollectionThunk } from "../services/ApiServiceImpl";

export const reviewsSlice = createSlice({
    name: "reviews",
    initialState: InitialReviews,
    reducers: {},
    extraReducers: (builder) => {
        // handle get /review
        handleCollectionThunk(builder, ReviewServiceImpl.getUserReviewsThunk);

        // handle post /review
        builder.addCase(
            ReviewServiceImpl.createReviewThunk.fulfilled,
            (state, action) => {
                state.rows.push(action.payload as ReviewDTO);
            }
        );
    },
});

export const selectReviews = (state: AppState) => {
    return state.reviews;
};

export const getReviewCreatedTime = (
    t: TFunction,
    review: ReviewDTO,
    useShortPrefix = false
) => {
    return getCreatedTime(
        t,
        review.createdAt,
        useShortPrefix ? "short" : "default"
    );
};

export default reviewsSlice.reducer;
